import { post } from '../axios'

// 选项组重排序
export function poll_changeSort_post(map, option) {
  return post(`${process.env.VUE_APP_POLL}/poll/changeSort`, map, option).then(
    response => response
  )
}

// 删除投票选项组
export function poll_deleteOptionGroup_post(map, option) {
  return post(
    `${process.env.VUE_APP_POLL}/poll/deleteOptionGroup`,
    map,
    option
  ).then(response => response)
}

// 查询投票选项组列表
export function poll_listOptionGroup_post(map, option) {
  return post(
    `${process.env.VUE_APP_POLL}/poll/listOptionGroup`,
    map,
    option
  ).then(response => response)
}

// 查询投票选项组详情
export function poll_optionGroupDetail_post(map, option) {
  return post(
    `${process.env.VUE_APP_POLL}/poll/optionGroupDetail`,
    map,
    option
  ).then(response => response)
}

// 投票活动分页列表
export function poll_pageList_post(map, option) {
  return post(`${process.env.VUE_APP_POLL}/poll/pageList`, map, option).then(
    response => response
  )
}

// 新增/编辑投票活动
export function poll_save_post(map, option) {
  return post(`${process.env.VUE_APP_POLL}/poll/save`, map, option).then(
    response => response
  )
}

// 新增/编辑投票选项组
export function poll_saveOptionGroup_post(map, option) {
  return post(
    `${process.env.VUE_APP_POLL}/poll/saveOptionGroup`,
    map,
    option
  ).then(response => response)
}

// 禁用/启用投票选项组
export function poll_updateOptionGroupStatus_post(map, option) {
  return post(
    `${process.env.VUE_APP_POLL}/poll/updateOptionGroupStatus`,
    map,
    option
  ).then(response => response)
}
